import { render, staticRenderFns } from "./PleitoForm.vue?vue&type=template&id=c10013ac"
import script from "./PleitoForm.vue?vue&type=script&lang=js"
export * from "./PleitoForm.vue?vue&type=script&lang=js"
import style0 from "./PleitoForm.vue?vue&type=style&index=0&id=c10013ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports